// ExceptionHandler.cs writes JsonConvert.SerializeObject(exception.Message), so an API error body
// reaches the client as a JSON-encoded string, quotes included. Unwrap it where possible so a
// server message can be shown on its own.
const unwrapServerErrorMessage = (err: unknown): string => {
    if (typeof err !== 'string') {
        return err instanceof Error ? err.message : String(err ?? '');
    }
    try {
        const parsed = JSON.parse(err);
        return typeof parsed === 'string' ? parsed : err;
    } catch {
        return err;
    }
};

/**
 * Returns the server's message when an error is a duplicate-study rejection from
 * StudyManagerService.CheckForDuplicateStudies ("A study with ID ... already exists on the
 * Vivli Platform."), otherwise null. Used by the Study Submission save and NCT lookup error
 * handlers so the duplicate message is shown alone rather than inside a generic error.
 */
export const getStudyAlreadyExistsMessage = (err: unknown): string | null => {
    const message = unwrapServerErrorMessage(err);
    return message.toLowerCase().includes('already exists') ? message : null;
};
